<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100"><br>
      <div v-if="showAlert" class="alert">{{uploadMessage}}</div>
      <h3>Campaña 1 <em>(Se muestra al iniciar la aplicación)</em></h3>
      <label><strong>Seleccione el archivo XLS/XLSX de datos : </strong>
        <input type="file" id="file" ref="file" v-on:change="handleFileUpload(0)"/>
      </label>
      <button v-if="!uploading" class="md-button md-large md-success" v-on:click="submitFile(1)">Subir</button>
      <span v-else >Adjuntando archivo, aguarde unos instantes...</span>
    </div>
    <div class="md-layout-item md-size-100"><br>
      <h3>Campaña 2</h3>
      <label><strong>Seleccione el archivo XLS/XLSX de datos : </strong>
        <input type="file" id="file1" ref="file1" v-on:change="handleFileUpload(1)"/>
      </label>
      <button v-if="!uploading" class="md-button md-large md-success" v-on:click="submitFile(2)">Subir</button>
      <span v-else >Adjuntando archivo, aguarde unos instantes...</span>
    </div>
    <div class="md-layout-item md-size-100"><br>
      <h3>Campaña 3</h3>
      <label><strong>Seleccione el archivo XLS/XLSX de datos : </strong>
        <input type="file" id="file2" ref="file2" v-on:change="handleFileUpload(2)"/>
      </label>
      <button v-if="!uploading" class="md-button md-large md-success" v-on:click="submitFile(3)">Subir</button>
      <span v-else >Adjuntando archivo, aguarde unos instantes...</span>
    </div>
    <div class="md-layout-item md-size-100"><br>
      <h3>Campaña 4</h3>
      <label><strong>Seleccione el archivo XLS/XLSX de datos : </strong>
        <input type="file" id="file3" ref="file3" v-on:change="handleFileUpload(3)"/>
      </label>
      <button v-if="!uploading" class="md-button md-large md-success" v-on:click="submitFile(4)">Subir</button>
      <span v-else >Adjuntando archivo, aguarde unos instantes...</span>
    </div>
    <div class="md-layout-item md-size-100"><br>
      <h3>Campaña 5</h3>
      <label><strong>Seleccione el archivo XLS/XLSX de datos : </strong>
        <input type="file" id="file4" ref="file4" v-on:change="handleFileUpload(4)"/>
      </label>
      <button v-if="!uploading" class="md-button md-large md-success" v-on:click="submitFile(5)">Subir</button>
      <span v-else >Adjuntando archivo, aguarde unos instantes...</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'upload',
  data(){
    return {
      file: '',
      uploading: false,
      uploadMessage: '',
      showAlert: false
    }
  },
  methods: {
    submitFile(filenumber) {
      this.showAlert = false;
      let formData = new FormData();
      this.uploading = true;
      formData.append('filenumber', filenumber);
      formData.append('file', this.file);
      console.log(this.file);
      axios.post( '/upload.php',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(() => {
        this.uploading = false;
        this.uploadMessage = 'El archivo se adjunto correctamente. Recargue esta pagina para que la plataforma levante el nuevo archivo';
        this.showAlert = true;
      })
        .catch((er) => {
          this.uploading = false;
          this.uploadMessage = er;
          this.showAlert = true;
        });

    },
    handleFileUpload(number){
      switch (number) {
      case 0: this.file = this.$refs.file.files[0]; break;
      case 1: this.file = this.$refs.file1.files[0]; break;
      case 2: this.file = this.$refs.file2.files[0]; break;
      case 3: this.file = this.$refs.file3.files[0]; break;
      case 4: this.file = this.$refs.file4.files[0]; break;
      }
    }
  }
}
</script>
